import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { IType } from '../../../../types/IType';
import { Icon } from '@progress/kendo-react-common';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { ComboBoxFilterChangeEvent, DropDownTree } from '@progress/kendo-react-dropdowns';
import { expandedState, processTreeData } from '../../../../utils/TreeDataOperations';
import { PartialSpinny } from '../../../Nav/Spinny';
import { Skeleton } from '@progress/kendo-react-indicators';
import { AdaptiveModeContext } from '@progress/kendo-react-common';
import { UserApi } from '../../../../redux/api/UserApi';

interface TicketType {
    id: number;
    name: string;
}

interface TypeProps extends ITicketProps {
    showHeader?: boolean;
    isOpen?: boolean;
}

const TicketType: React.FC<TypeProps> = (ticket) => {
    const { data: profile } = UserApi.useGetUserProfileQuery();
    //Get a list to types from the API
    const { data: typesList } = TicketApi.useGetMyTypeListQuery(-1)
    const [updateType, { isLoading: isUpdating }] = TicketApi.useUpdateTypeMutation();
    const [show, setShow] = useState(ticket.isOpen);
    const [filter, setFilter] = useState('');

    //Update the show state during the close validation popup steps.
    useEffect(() => {
        setShow(ticket.isOpen)
    }
        , [ticket.isOpen]);

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
    };


    const filteredTypes = typesList?.filter(type =>
        type.Call_Type.toLowerCase().includes(filter.toLowerCase())
    );


    //const typeItems = typesList?.filter(l=>{l.Level === 1});
    function fillLevelTypes(type: IType[]) {
        return type?.map((t) => {
            const result: any = {
                id: t.ID,
                text: t.Call_Type,
                items: fillLevelTypes(typesList.filter(tf => tf.Parent_Id === t.ID))
            }
            return result;
        });
    }

    const itemSelected = (e) => {
        console.log('itemSelected', e, popRef?.current)

        setShow(false)
    }

    const onClick = (e) => {
        // offSet.current = {
        //     //left: e.nativeEvent.x,
        //     left: dropRef.current.element.getBoundingClientRect().left,
        //     top: e.nativeEvent.y,
        // };
        setShow((s) => !s);

    };

    const typeItems = useMemo(() => fillLevelTypes(filteredTypes?.filter(l => l.Parent_Id === null)), [filteredTypes])

    const popRef = useRef(null);
    const dropRef = useRef(null);
    const anchor = useRef(null);

    const onFilterChange = (e: ComboBoxFilterChangeEvent) => {
        console.log('Change comes from within', e.filter.value)
        setFilter(e.filter.value)

        setShow(true);
    }

    //Tree stuffs
    const selectField = 'selected';
    const expandField = 'expanded';
    const dataItemKey = 'id';
    const textField = 'text';
    const subItemsField = 'items';
    const fields = {
        selectField,
        expandField,
        dataItemKey,
        subItemsField,
        textField
    };
    const [expanded, setExpanded] = React.useState([]);
    const [value, setValue] = React.useState(null);

    const onChange = event => {
        setValue(event.value);

        //console.log('onChange', event.value)

        //update thje ticket via the api
        updateType({ ticketId: ticket.ID, typeId: event.value[dataItemKey] }).unwrap().then(() => {
            //overkill
            //toast.success('Type updated successfully')
        }).catch((e) => {
            console.error('Error updating type', e)
        });
    }

    const onTreeFilterChange = event => setNewFilter(event.filter);
    const [newFilter, setNewFilter] = React.useState({
        value: '',
        operator: 'contains'
    });
    const treeData = React.useMemo(() => {

        var newData = processTreeData(typeItems || [], {
            expanded,
            value: newFilter.value,
            filter: newFilter
        }, fields)

        //expand all nodes
        //newData.map(d => d.expanded = true);
        //console.log('treeData useMemo', newFilter, expanded, newData, fields);

        return newData;
    }, [expanded, value, newFilter, typeItems]);
    const onExpandChange = React.useCallback(event => setExpanded(expandedState(event.item, dataItemKey, expanded)), [expanded]);

    //Populate the value with the current type
    useEffect(() => {
        if (ticket?.Type_Id) {
            setValue({ id: ticket?.Type_Id, name: ticket?.Call_Type_Path })
        }
    }, [ticket?.Type_Id]);

    return (
        <Card className="type">
            {ticket.showHeader == false ? <></> : <CardHeader>
                <Icon size='large' name='categorize' />{profile?.Phrases.CallPhrase} Type<i></i>
            </CardHeader>}
            <CardBody>
                {ticket.Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '30px', marginTop: '2px' }} /> :
                    <>
                        {isUpdating && <PartialSpinny />}
                        <AdaptiveModeContext.Provider value={{ small: 1024, medium: 1024 }}>
                            <DropDownTree adaptive={true} adaptiveTitle='Select a type' className='call-type-dropdown'
                                style={{ width: '100%' }}
                                placeholder={ticket?.Call_Type_Path || 'Select...'}
                                data={treeData}
                                value={value}
                                onChange={onChange}
                                textField={textField}
                                dataItemKey={dataItemKey}
                                onExpandChange={onExpandChange}
                                filterable={true}
                                onFilterChange={onTreeFilterChange}
                                filter={newFilter.value}
                                popupSettings={{ width: 300, collision: { vertical: 'fit', horizontal: 'none' }, positionMode: 'absolute', anchorAlign: { horizontal: 'right', vertical: 'top' }, className: 'call-type-popup' }}
                                opened={show}
                                onOpen={() => setShow(true)}
                                onClose={() => setShow(false)}
                            />
                        </AdaptiveModeContext.Provider>
                    </>

                }
            </CardBody>

        </Card >
    );
};

export default TicketType;